import { z } from 'zod/v4';

import { createdAtSchemaLegacy } from '../../../common/schemas/legacy/created-at';

import { indentLegacyDataSchema } from './data';
import { indentStylesSchemaLegacy } from './styles';

/**
 * Legacy `indent` widget envelope — its only placement (`params: defaultWidgetParams`
 * unmodified, i.e. `type: ['default']`; never `'zero'`/`'specific'`). No `type`
 * discriminator: single shape, created through the plain-widget factory path that
 * never stamps one.
 *
 * `mobileStyles` is `nullish` because widgets created before the per-device height
 * shipped have none — the renderer then falls back to the desktop height.
 */
export const indentLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('indent'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    data: indentLegacyDataSchema,
    styles: indentStylesSchemaLegacy,
    mobileStyles: indentStylesSchemaLegacy.nullish(),
});
